"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("../../styles/mapa.css");
var UFS_1 = require("./UFS");
var PASSO = 0.1, WIDTH = 450, HEIGHT = 460;
exports.default = (function (_a) {
    var onClick = _a.onClick, _b = _a.current_state, current_state = _b === void 0 ? [] : _b;
    var _c = (0, react_1.useState)(1), zoom = _c[0], setZoom = _c[1];
    var handleZoom = function (value) {
        var result = zoom + value;
        if (result < 1 || result > 1.4)
            return;
        setZoom(result);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'mapa-container' }, { children: [(0, jsx_runtime_1.jsx)("section", { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: { transform: "scale(".concat(zoom, ") translateX(").concat(((zoom - 1) * 100) / 2, "%) translateY(").concat(((zoom - 1) * 100) / 2, "%) ") } }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ version: "1.1", id: "svg-map", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", x: "0px", y: "0px", width: WIDTH, height: HEIGHT, viewBox: "0 0 ".concat(WIDTH, " ").concat(HEIGHT) }, { children: (0, jsx_runtime_1.jsx)("g", { children: UFS_1.UFS.map(function (payload, i) {
                                var indexof = current_state.findIndex(function (v) { return v.id == payload.id; });
                                var selectedItem = (indexof === -1) ? null : current_state[indexof];
                                var isSelected = !selectedItem ? false : (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.cidades.length) > 0 ? true : false;
                                return ((0, jsx_runtime_1.jsx)("a", __assign({ onClick: function () { return onClick(payload); }, className: "".concat(isSelected ? "uf-selected" : "") }, { children: payload.component }), i));
                            }) }, void 0) }), void 0) }), void 0) }, void 0), (0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return handleZoom(PASSO); } }, { children: " + " }), void 0), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return handleZoom(PASSO * -1); } }, { children: " - " }), void 0)] }, void 0)] }), void 0));
});
//# sourceMappingURL=index.js.map